
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isProjectsOpen, setIsProjectsOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  const handleLinkClick = () => {
    setIsMobileMenuOpen(false);
    setIsProjectsOpen(false);
    // Use setTimeout to ensure the navigation completes before scrolling
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  };

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
      <div className="w-full px-3 sm:px-4 lg:px-6">
        <div className="flex items-center justify-between h-16 sm:h-18 lg:h-20">
          <Link to="/" className="flex items-center flex-shrink-0 min-w-0" onClick={handleLinkClick}>
            <img 
              src="https://lh3.googleusercontent.com/pw/AP1GczPbzJrA_Fq8W1ugvEbfsp-XpSoue36xUuINYE1_lIgx-WQL3Msb3yw5eUjog3GkZUiXRdh8OBeqPmBIBLTLUv3E3P4drGBWm1-yUpFkEWNtsDUC0IM=w189-h50-no"
              alt="CANAL REALTY"
              className="h-8 sm:h-10 md:h-12 lg:h-14 w-auto object-contain flex-shrink-0"
              style={{ minWidth: '140px', maxWidth: '200px' }}
              onError={(e) => {
                console.log('Header logo failed to load');
                e.currentTarget.src = 'https://via.placeholder.com/189x50/333333/ffffff?text=CANAL+REALTY';
              }}
            />
          </Link>
          
          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-6 xl:space-x-8 flex-shrink-0">
            <Link 
              to="/" 
              className={`text-sm xl:text-base font-medium transition-colors whitespace-nowrap ${
                isActive('/') ? 'text-[#9B1F3A]' : 'text-gray-800 hover:text-[#9B1F3A]'
              }`}
              style={{ fontFamily: 'Helvetica, Arial, sans-serif' }}
              onClick={handleLinkClick}
            >
              Home
            </Link>
            
            <div className="relative">
              <button
                onClick={() => setIsProjectsOpen(!isProjectsOpen)}
                className="text-sm xl:text-base font-medium text-gray-800 hover:text-[#9B1F3A] transition-colors flex items-center cursor-pointer whitespace-nowrap"
                style={{ fontFamily: 'Helvetica, Arial, sans-serif' }}
              >
                Projects
                <i className={`ri-arrow-down-s-line ml-1 transition-transform ${isProjectsOpen ? 'rotate-180' : ''}`}></i>
              </button>
              
              {isProjectsOpen && (
                <div className="absolute top-full left-0 mt-2 w-48 bg-white border border-gray-200 shadow-lg rounded-md z-50">
                  <Link 
                    to="/projects/commercial" 
                    className="block px-4 py-3 text-sm text-gray-800 hover:bg-gray-50 hover:text-[#9B1F3A] transition-colors first:rounded-t-md"
                    onClick={() => {
                      setIsProjectsOpen(false);
                      handleLinkClick();
                    }}
                  >
                    Commercial
                  </Link>
                  <Link 
                    to="/projects/residential" 
                    className="block px-4 py-3 text-sm text-gray-800 hover:bg-gray-50 hover:text-[#9B1F3A] transition-colors"
                    onClick={() => {
                      setIsProjectsOpen(false);
                      handleLinkClick();
                    }}
                  >
                    Residential
                  </Link>
                  <Link 
                    to="/projects/industrial" 
                    className="block px-4 py-3 text-sm text-gray-800 hover:bg-gray-50 hover:text-[#9B1F3A] transition-colors last:rounded-b-md"
                    onClick={() => {
                      setIsProjectsOpen(false);
                      handleLinkClick();
                    }}
                  >
                    Industrial
                  </Link>
                </div>
              )}
            </div>
            
            <Link 
              to="/contact" 
              className={`text-sm xl:text-base font-medium transition-colors whitespace-nowrap ${
                isActive('/contact') ? 'text-[#9B1F3A]' : 'text-gray-800 hover:text-[#9B1F3A]'
              }`}
              style={{ fontFamily: 'Helvetica, Arial, sans-serif' }}
              onClick={handleLinkClick}
            >
              Contact
            </Link>
            
            <Link 
              to="/investor-portal" 
              className={`text-sm xl:text-base font-medium transition-colors whitespace-nowrap ${
                isActive('/investor-portal') ? 'text-[#9B1F3A]' : 'text-gray-800 hover:text-[#9B1F3A]'
              }`}
              style={{ fontFamily: 'Helvetica, Arial, sans-serif' }}
              onClick={handleLinkClick}
            >
              Investor Portal
            </Link>
          </nav>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-3 text-gray-800 hover:text-[#9B1F3A] transition-colors flex-shrink-0 ml-2"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="lg:hidden border-t border-gray-200 bg-white">
            <div className="px-2 pt-2 pb-3 space-y-1">
              <Link 
                to="/" 
                className={`block px-3 py-3 text-base font-medium transition-colors ${
                  isActive('/') ? 'text-[#9B1F3A] bg-gray-50' : 'text-gray-800 hover:text-[#9B1F3A] hover:bg-gray-50'
                }`}
                style={{ fontFamily: 'Helvetica, Arial, sans-serif' }}
                onClick={handleLinkClick}
              >
                Home
              </Link>
              
              <div>
                <button
                  onClick={() => setIsProjectsOpen(!isProjectsOpen)}
                  className="w-full text-left px-3 py-3 text-base font-medium text-gray-800 hover:text-[#9B1F3A] hover:bg-gray-50 transition-colors flex items-center justify-between"
                  style={{ fontFamily: 'Helvetica, Arial, sans-serif' }}
                >
                  Projects
                  <i className={`ri-arrow-down-s-line transition-transform ${isProjectsOpen ? 'rotate-180' : ''}`}></i>
                </button>
                
                {isProjectsOpen && (
                  <div className="pl-6 space-y-1">
                    <Link 
                      to="/projects/commercial" 
                      className="block px-3 py-2 text-sm text-gray-600 hover:text-[#9B1F3A] hover:bg-gray-50 transition-colors"
                      onClick={handleLinkClick}
                    >
                      Commercial
                    </Link>
                    <Link 
                      to="/projects/residential" 
                      className="block px-3 py-2 text-sm text-gray-600 hover:text-[#9B1F3A] hover:bg-gray-50 transition-colors"
                      onClick={handleLinkClick}
                    >
                      Residential
                    </Link>
                    <Link 
                      to="/projects/industrial" 
                      className="block px-3 py-2 text-sm text-gray-600 hover:text-[#9B1F3A] hover:bg-gray-50 transition-colors"
                      onClick={handleLinkClick}
                    >
                      Industrial
                    </Link>
                  </div>
                )}
              </div>
              
              <Link 
                to="/contact" 
                className={`block px-3 py-3 text-base font-medium transition-colors ${
                  isActive('/contact') ? 'text-[#9B1F3A] bg-gray-50' : 'text-gray-800 hover:text-[#9B1F3A] hover:bg-gray-50'
                }`}
                style={{ fontFamily: 'Helvetica, Arial, sans-serif' }}
                onClick={handleLinkClick}
              >
                Contact
              </Link>
              
              <Link 
                to="/investor-portal" 
                className={`block px-3 py-3 text-base font-medium transition-colors ${
                  isActive('/investor-portal') ? 'text-[#9B1F3A] bg-gray-50' : 'text-gray-800 hover:text-[#9B1F3A] hover:bg-gray-50'
                }`}
                style={{ fontFamily: 'Helvetica, Arial, sans-serif' }}
                onClick={handleLinkClick}
              >
                Investor Portal
              </Link>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
